import { Permission } from "models/Permission";
import { AppStore } from "App/Store";

export const allowMetadataUpdate = (store: AppStore) => {
  const { allowTables } = store.UserToken;
  for (const allowTable of allowTables) {
    const permission = new Permission(allowTable.allow.split(""));
    switch (allowTable.table) {
      case "metadata":
        if (
          !permission.isUserReadable() ||
          !permission.isUserEditable() ||
          !permission.isGroupReadable() ||
          !permission.isGroupEditable() ||
          !permission.isOtherEditable()
        ) {
          return false;
        }
        break;
      default:
        break;
    }
  }
  return true;
};
